import { useEffect } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { useTranslation } from '../i18n'

const APP_NAME = 'TESSET Hub'

// Ordered, most-specific-first. matchPath is exact (end:true) in RR6.
const TITLE_ROUTES: ReadonlyArray<{ pattern: string; key: string }> = [
  { pattern: '/my/wifi', key: 'wifi.title' },
  { pattern: '/companies/new', key: 'companies.title' },
  { pattern: '/companies/:id/edit', key: 'companies.title' },
  { pattern: '/companies', key: 'companies.title' },
  { pattern: '/coworkers', key: 'coworkers.title' },
  { pattern: '/my/guests/new', key: 'guestInvitations.title' },
  { pattern: '/my/guests', key: 'guestInvitations.title' },
  { pattern: '/wifi-networks/new', key: 'wifiNetworks.title' },
  { pattern: '/wifi-networks/:id/edit', key: 'wifiNetworks.title' },
  { pattern: '/wifi-networks', key: 'wifiNetworks.title' },
  { pattern: '/buildings/new', key: 'buildings.title' },
  { pattern: '/buildings/:id/edit', key: 'buildings.title' },
  { pattern: '/buildings/:buildingId/rooms/new', key: 'rooms.title' },
  { pattern: '/buildings/:buildingId/rooms/:roomId/edit', key: 'rooms.title' },
  { pattern: '/buildings/:buildingId/rooms', key: 'buildings.title' },
  { pattern: '/buildings/:id/bookings/new', key: 'bookings.title' },
  { pattern: '/buildings/:id/bookings/:bookingId/edit', key: 'bookings.title' },
  { pattern: '/buildings/:id/bookings', key: 'bookings.title' },
  { pattern: '/buildings/:id/calendar/:viewMode', key: 'buildingCalendar.title' },
  { pattern: '/buildings', key: 'buildings.title' },
  { pattern: '/my/bookings/new', key: 'roomBrowse.title' },
  { pattern: '/my/bookings/:bookingId/edit', key: 'myBookings.title' },
  { pattern: '/my/bookings', key: 'myBookings.title' },
  { pattern: '/audit-log', key: 'auditLog.title' },
  { pattern: '/my/profile', key: 'myProfile.title' },
  { pattern: '/admin/printers/new', key: 'printers.title' },
  { pattern: '/admin/printers/:id', key: 'printers.title' },
  { pattern: '/admin/printers', key: 'printers.title' },
  { pattern: '/my/print', key: 'print.title' },
  { pattern: '/p/:printerId', key: 'print.title' },
  { pattern: '/not-enrolled', key: 'notEnrolled.title' },
]

export function RouteTitle() {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  useEffect(() => {
    const match = TITLE_ROUTES.find((r) => matchPath(r.pattern, pathname))
    document.title = match ? `${t(match.key)} · ${APP_NAME}` : APP_NAME
  }, [pathname, t])

  return null
}
